module.exports = __webpack_public_path__ + "static/media/BR2.ce91055a.png";